export const FLAG_COMPLETE_ANIMATION_DELAY_MS = 2000

// Mirrors PackageFlag::MAX_REASON_LENGTH on the backend. The counter measures
// [...value].length (Unicode code points), which matches Ruby's String#length —
// a newline counts as one character on both sides.
export const MAX_REASON_LENGTH = 500

export const FLAG_STATE = {
  DRAFTED: 'drafted',
  REPORTED: 'reported',
  FIXED: 'fixed',
  ACCEPTED: 'accepted',
  NOT_ACCEPTED: 'not_accepted',
}

export const APPLICANT_REVIEWING_STATES = [FLAG_STATE.REPORTED, FLAG_STATE.NOT_ACCEPTED]
export const APPLICANT_COMPLETED_STATES = [FLAG_STATE.FIXED, FLAG_STATE.ACCEPTED]

export const PROCESSOR_REVIEWING_STATES = [
  FLAG_STATE.DRAFTED,
  FLAG_STATE.REPORTED,
  FLAG_STATE.FIXED,
  FLAG_STATE.NOT_ACCEPTED,
]
export const PROCESSOR_RESOLVED_STATES = [FLAG_STATE.ACCEPTED]

export const APPLICANT_ROLES = ['broker', 'resident', 'client', 'spectator']
export const PROCESSOR_ROLES = ['managing_agent', 'closing_agent', 'alterations_admin']
export const BOARD_MEMBER_ROLES = ['board_member']

export const ACKNOWLEDGEMENT_RESPONSE_STATE = {
  COMPLETE: 'complete',
  INCOMPLETE: 'incomplete',
}
